import React from 'react';
import { Popover } from '@mui/material';
import theme from 'assets';


interface IFilterEditor {
    target?: Element
    onClose: () => void

    children: React.ReactNode
}

let FilterEditor = (props: IFilterEditor) => {
    return (
        <Popover
            open={props.target !== undefined}
            anchorEl={props.target}
            onClose={props.onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <div style={{ padding: theme.spacing(), minWidth: 200 }}>
                {props.children}
            </div>
        </Popover>
    )
}

export default FilterEditor;